import getPaginationPagesToDisplay from '../get-pagination-pages-to-display';

type GetPaginationDataParams = {
  amountOfPages: number;
  currentPageNumber: number;
};

const getPaginationData = ({ amountOfPages, currentPageNumber }: GetPaginationDataParams) => ({
  canGoBack: currentPageNumber > 1,
  canGoForward: currentPageNumber < amountOfPages,
  pagesToDisplay: getPaginationPagesToDisplay({ amountOfPages, currentPageNumber }),
});

export default getPaginationData;
